module.exports = __webpack_public_path__ + "static/japan03-feb08f32c57096369355139f4a540737.jpg";